function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8174 8.19898L15.2529 11.6346L15.2693 11.4546C15.2693 9.64954 13.8024 8.18262 11.9974 8.18262L11.8174 8.19898Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9976 6.00153C15.0078 6.00153 17.4509 8.44462 17.4509 11.4549C17.4509 12.1583 17.3091 12.8291 17.0637 13.4453L20.2539 16.6355C21.9008 15.2613 23.1987 13.4835 24.0003 11.4549C22.1081 6.66687 17.4564 3.2749 11.9976 3.2749C10.4707 3.2749 9.00924 3.54754 7.65137 4.03834L10.0072 6.38869C10.6233 6.14877 11.2941 6.00153 11.9976 6.00153Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.09064 3.02926L3.57735 5.51596L4.07363 6.01224C2.27403 7.41919 0.850716 9.28969 0 11.4546C1.88687 16.2426 6.54398 19.6345 11.9973 19.6345C13.6878 19.6345 15.302 19.3074 16.7799 18.7129L17.2434 19.1764L20.4227 22.3612L21.8133 20.9761L2.48124 1.63867L1.09064 3.02926ZM7.12203 9.05518L8.8071 10.7403C8.75802 10.9748 8.72531 11.2092 8.72531 11.4546C8.72531 13.2597 10.1922 14.7266 11.9973 14.7266C12.2427 14.7266 12.4772 14.6939 12.7062 14.6448L14.3913 16.3299C13.666 16.6897 12.8589 16.908 11.9973 16.908C8.98707 16.908 6.54398 14.4648 6.54398 11.4546C6.54398 10.593 6.76212 9.78591 7.12203 9.05518Z"
});

function SvgCrossedEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossedEye);
export default __webpack_public_path__ + "static/media/crossedEye.84a50331.svg";
export { ForwardRef as ReactComponent };